import React from 'react';
import { FormattedMessage } from 'react-intl';

export default [
  { key: '01_free_on_premise', label: <FormattedMessage id="hosting.parking_types.free_onsite" defaultMessage="Free onsite parking"/>, index: 0 },
  { key: '02_paid_on_premise', label: <FormattedMessage id="hosting.parking_types.paid_onsite" defaultMessage="Paid onsite parking"/>, index: 1 },
  { key: '03_free_street', label: <FormattedMessage id="hosting.parking_types.free_street" defaultMessage="Free street parking"/>, index: 2 },
  { key: '04_metered_street', label: <FormattedMessage id="hosting.parking_types.metered_street" defaultMessage="Metered street parking"/>, index: 3 },
  { key: '05_valet', label: <FormattedMessage id="hosting.parking_types.valet" defaultMessage="Valet"/>, index: 4 },
  { key: '06_nearby_lot', label: <FormattedMessage id="hosting.parking_types.nearby_lot" defaultMessage="Nearby parking lot"/>, index: 5 }
];
